import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    
  
    return (
      <React.Fragment>
        <TableRow >
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.Qty}
          </TableCell>
          <TableCell align="center">{row.Plant}</TableCell>
          <TableCell align="center">{row.Type}</TableCell>
          <TableCell align="center">{row.permanent==true?"Yes":"No"}</TableCell>
          <TableCell align="center">{row.LE+"/"+row.Hours}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Details {row.Plant} x{row.Qty}
                </Typography>
                <Table size="small" aria-label="purchases" style={{width:"30%"}}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Time</TableCell>
                      <TableCell>LE Ammount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    
                      <TableRow key={1}>
                        <TableCell component="th" scope="row">1 hr</TableCell>
                        <TableCell>{((row.LE/row.Hours)*row.Qty).toFixed(2)}</TableCell>
                      </TableRow>
                      <TableRow key={2}>
                        <TableCell component="th" scope="row">1 Day</TableCell>
                        <TableCell>{((row.LE/row.Hours)*row.Qty*24).toFixed(2)}</TableCell>
                      </TableRow>
                      <TableRow key={3}>
                        <TableCell component="th" scope="row">3 Days</TableCell>
                        <TableCell>{((row.LE/row.Hours)*row.Qty*24*3).toFixed(2)}</TableCell>
                      </TableRow>
                      <TableRow key={4}>
                        <TableCell component="th" scope="row">6 Days</TableCell>
                        <TableCell>{((row.LE/row.Hours)*row.Qty*24*6).toFixed(2)}</TableCell>
                      </TableRow>
                      <TableRow key={5}>
                        <TableCell component="th" scope="row">30 Days</TableCell>
                        <TableCell>{((row.LE/row.Hours)*row.Qty*24*30).toFixed(2)}</TableCell>
                      </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

function PVUTable() {
  const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  
  const handleClickOpenAddPlant = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const AddNewPlant=()=>{
    setPlants([...Plants,{Plant:NewPlant.Plant,Type:NewPlant.Type,LE:NewPlant.LE,Hours:NewPlant.Hours,permanent:NewPlant.permanent,Qty:NewPlant.Qty}]);
    console.log(Plants);
    handleCloseDialog();
  }
  const [NewPlant, setNewPlant] = useState({
    Plant:"",
    Type: "",
    Hours:0,
    LE: 0,
    permanent: false,
    Qty:0
  });
  const HandleTextChange = (Value, Field) => {
    setNewPlant({ ...NewPlant, [Field]: Value });
    console.log(NewPlant);
  };
  const [Plants, setPlants] = useState([
    {
      Plant: "Sunflower Sapling",
      Type: "Normal",
      LE: 250,
      Hours:72,
      permanent: false,
      Qty:5
    },
    {
      Plant: "Sunflower Mama",
      Type: "Normal",
      LE: 850,
      Hours:144,
      permanent: false,
      Qty:1
    },
  ]);
  return (
    <div>
      <div
        style={{
          border: "solid white 1px",
          width: "96%",
          height: "50%",
          margin: "auto",
          borderRadius: "10px",
          padding: "10px",
          marginTop: "10px",
          textAlign: "right",
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClickOpenAddPlant}
          endIcon={<AddCircleOutlineIcon
            />}
        >
          ADD PLANT
        </Button>
        <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">ADD PLANT</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Plant"
            fullWidth
            onChange={(event)=>{HandleTextChange(event.target.value,"Plant")}}
          />
                    <TextField
            autoFocus
            margin="dense"
            label="Type"
            fullWidth
            onChange={(event)=>{HandleTextChange(event.target.value,"Type")}}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Quantity"
            type="number"
            fullWidth
            onChange={(event)=>{HandleTextChange(event.target.value,"Qty")}}
          />
            <TextField
            autoFocus
            margin="dense"
            label="LE"
            type="number"
            fullWidth
            onChange={(event)=>{HandleTextChange(event.target.value,"LE")}}
          />
                      <TextField
            autoFocus
            margin="dense"
            label="Hours"
            type="number"
            fullWidth
            onChange={(event)=>{HandleTextChange(event.target.value,"Hours")}}
          />
               <FormControlLabel
        control={<Checkbox state={false}  name="checkedA" onChange={(event)=>{HandleTextChange(event.target.checked,"permanent")}}/>}
        label="NFT Plant?"
        
      />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button onClick={AddNewPlant} color="primary" variant="outlined" >
            ADD
          </Button>
        </DialogActions>
      </Dialog>
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Qty</TableCell>
                <TableCell align="center">Plant</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Permanent</TableCell>
                <TableCell align="center">LE/h</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Plants.map((row,i) => (
            <Row key={i} row={row} />
          ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      

        <div>
      </div>
    </div>
  );
}

export default PVUTable;
